import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { InputText, Text } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import {
  OTHER_SERVICES,
  OtherServicesFormDataType,
} from "@validations/HRM/employee/sevicesValidation";

export const OtherServicesForm = ({
  isProfileDisabled,
}: {
  isProfileDisabled: boolean;
}) => {
  const { t } = useTranslation();

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<OtherServicesFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <InputTextRow
        register={{ ...register(OTHER_SERVICES.NAME_OF_EMPLOYER) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.NAME_OF_EMPLOYER"
        error={errors}
        required
       disabled={isProfileDisabled}
      />
      <InputTextRow
        register={{ ...register(OTHER_SERVICES.ADDRESS) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.ADDRESS"
        error={errors}
        required
       disabled={isProfileDisabled}
      />
      <InputTextRow
        register={{ ...register(OTHER_SERVICES.TYPE_OF_SERVICE) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.TYPE_OF_SERVICE"
        error={errors}
        required
       disabled={isProfileDisabled}
      />
      <InputTextRow
        register={{ ...register(OTHER_SERVICES.POSITION) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.POSITION"
        error={errors}
        required
       disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.FROM_DATE"
        control={control}
        register={{ ...register(OTHER_SERVICES.FROM_DATE) }}
        errors={errors}
        name={OTHER_SERVICES.FROM_DATE}
        required
       disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.END_DATE"
        control={control}
        register={{ ...register(OTHER_SERVICES.END_DATE) }}
        errors={errors}
        name={OTHER_SERVICES.END_DATE}
        required
       disabled={isProfileDisabled}
      />
      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t(
              "EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.PAY_SCALE.LABEL",
            )}
          </Text>
        </div>

        <div className="d-flex justify-content-center gap-9 align-items-center col-md-12 col-lg-7">
          <div className="flex-fill">
            <InputText
              {...register(OTHER_SERVICES.PAY_SCALE_FROM)}
              suffix={
                <Text size="sm" color="subtitle1">
                  {t(
                    "EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.PAY_SCALE.PLACEHOLDER",
                  )}
                </Text>
              }
              error={errors as any}
             disabled={isProfileDisabled}
            />
          </div>
          <Text weight="semibold" color="title" size="sm">
            {t("EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.PAY_SCALE.TO")}
          </Text>
          <div className="flex-fill">
            <InputText
              {...register(OTHER_SERVICES.PAY_SCALE_TO)}
              suffix={
                <Text size="sm" color="subtitle1">
                  {t(
                    "EMPLOYEE.SERVICES_INFO.FORM.OTHER_SERVICES_INFO.PAY_SCALE.PLACEHOLDER",
                  )}
                </Text>
              }
              error={errors as any}
             disabled={isProfileDisabled}
            />
          </div>
        </div>
      </div>
      <MultiFileRow
        name="document"
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
       disabled={isProfileDisabled}
      />
    </div>
  );
};
